import type React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import { Layout } from "./components/Layout";
import { LoginPage } from "./pages/Login";
import { DashboardPage } from "./pages/Dashboard";
import { ChannelsPage } from "./pages/Channels";
import { ProductsPage } from "./pages/Products";
import { InboxPage } from "./pages/Inbox";
import { AgentSettingsPage } from "./pages/AgentSettings";
import { KnowledgeSourcesPage } from "./pages/KnowledgeSources";
import { EscalationRulesPage } from "./pages/EscalationRules";
import { WhatsAppTemplatesPage } from "./pages/WhatsAppTemplates";
import { UsersPage } from "./pages/Users";
import { AuditLogPage } from "./pages/AuditLog";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  return user ? <>{children}</> : <Navigate to="/login" replace />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="channels" element={<ChannelsPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="inbox" element={<InboxPage />} />
        <Route path="agents" element={<AgentSettingsPage />} />
        <Route path="knowledge" element={<KnowledgeSourcesPage />} />
        <Route path="escalation" element={<EscalationRulesPage />} />
        <Route path="templates" element={<WhatsAppTemplatesPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="audit" element={<AuditLogPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
